<template>
  <section
    class="login-page"
    style="
      background: url('./login.svg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top right;
    "
  >
    <div class="login-box">
      <div class="login-logo">
        <img src="@/assets/images/login-logo.svg" alt="logo" />
      </div>
      <div class="login-form">
        <form @submit.prevent="onSubmit">
          <div class="input-item">
            <label for="phone" :class="{ error: v$.form.email.$errors.length }"
              >Phone Number <span class="text-danger">*</span></label
            >
            <img src="@/assets/icon/smartphone1.png" alt="" />
            <input
              type="tel"
              v-model="v$.form.email.$model"
              id="phone"
              placeholder="Type your number"
            />
            <div
              class="input-errors"
              v-for="error of v$.form.email.$errors"
              :key="error.$uid"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
          </div>
          <div class="input-item">
            <label
              for="password"
              :class="{ error: v$.form.password.$errors.length }"
              >Password <span class="text-danger">*</span></label
            >
            <img src="@/assets/icon/lock1.png" alt="" />
            <input
              type="password"
              id="password"
              v-model="v$.form.password.$model"
              placeholder="Type your password"
            />
            <div
              class="input-errors"
              v-for="error of v$.form.password.$errors"
              :key="error.$uid"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
          </div>
          <div class="log-btn">
            <button type="submit">LOGIN</button>
            <!-- <p>Forgot Password?</p>
            <p>Contact Admin</p> -->
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
// import axios from "axios";
import useVuelidate from '@vuelidate/core';
import { maxLength, minLength, numeric, required } from '@vuelidate/validators';
import http from '../config/axios';
export default {
  name: 'Login',
  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      errorMesage: ''
    };
  },

  validations() {
    return {
      form: {
        email: {
          required,
          min: maxLength(11),
          numeric
        },
        password: {
          required,
          min: minLength(8)
        }
      }
    };
  },

  beforeCreate() {
    let token = localStorage.getItem('token');
    if (token) {
      this.$router.push({ name: 'dashboard' });
    }
  },

  methods: {
    onSubmit() {
      let mobile = this.form.email;
      let password = this.form.password;
      http
        .post('v1/users/login', { mobile, password })
        .then((response) => {
          let user = response.data.data;
          let userCode = user.userCode;
          let userName = user.name;
          let token = user.token;
          let permissions = user.permissions;
          localStorage.setItem('userCode', userCode);
          localStorage.setItem('userName', userName);
          localStorage.setItem('token', token);
          localStorage.setItem('userPermission', permissions);
          localStorage.setItem('role_name', 'Internal User');
          localStorage.setItem('modality', 'pool');
          localStorage.setItem('serviceType', 'B2C');
          if (user.token) {
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl);
              window.location.reload();
            } else {
              if (permissions.includes('dashboard')) {
                this.$router.push({ name: 'dashboard' });
                window.location.reload();
              } else {
                this.$swal({
                  title: 'Access Denied',
                  icon: 'warning',
                  type: 'warning',
                  text: 'You are not authorized for this application.'
                });
                localStorage.removeItem('token');
                localStorage.removeItem('userCode');
                localStorage.removeItem('role_name');
                localStorage.removeItem('userPermission');
                localStorage.removeItem('userName');
                localStorage.removeItem('serviceType');
              }
            }
          }
        })
        .catch((error) => {
          this.$swal({
            title: 'Error',
            icon: 'error',
            type: 'error',
            text: error.response?.data?.message
          });
          return;
        });
    }
  }
};
</script>
<style scoped>
/* start login page styles */
.login-page {
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top right;
  position: relative;
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  background: #fff;
  border-radius: 8px;
  padding: 50px;
}

.login-logo {
  text-align: center;
  margin-bottom: 30px;
}

.login-logo img {
  width: 150px;
}

.login-form form .input-item {
  position: relative;
  margin-bottom: 30px;
}

.login-form form .input-item label {
  font-weight: 600;
  margin-bottom: 7px;
  display: block;
}

.login-form form .input-item input {
  width: 100%;
  border: none;
  border-bottom: 2px solid #555;
  font-size: 14px;
  padding-left: 25px;
  padding-bottom: 5px;
}

.login-form form .input-item img {
  position: absolute;
  bottom: 10px;
  left: 2px;
}

.log-btn {
  text-align: center;
}

.log-btn button {
  border: none;
  background: #652d90;
  color: #fff;
  padding: 9px 60px;
  border-radius: 34px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 10px;
}

.log-btn p {
  margin-bottom: 2px;
  font-size: 13px;
}

@media all and (max-width: 480px) {
  .login-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 340px;
    background: #fff;
    border-radius: 8px;
    padding: 25px;
  }

  .login-logo img {
    width: 120px;
  }
}

/* end login page styles */
</style>
